import React from 'react';
import { SectionNotification } from 'wix-ui-tpa/cssVars';
import ErrorIcon from 'wix-ui-icons-common/on-stage/Error';
import { dataHooks } from '@wix/data-hooks';
import { useDeliverySectionData } from '../../provider/useDeliverySectionContext';
import { useLocaleKeys } from '../../locale-keys/LocaleKeys';
export const UnsupportedShippingDestinationErrorHooks = dataHooks('UnsupportedShippingDestinationError');
export const UnsupportedShippingDestinationError = () => {
  const localeKeys = useLocaleKeys();
  const {
    deliveryErrors
  } = useDeliverySectionData();
  const getErrorMessage = () => {
    if (deliveryErrors != null && deliveryErrors.externalCarrierError) {
      var _deliveryErrors$exter;
      return deliveryErrors == null || (_deliveryErrors$exter = deliveryErrors.externalCarrierError) == null ? void 0 : _deliveryErrors$exter.message;
    } else if (deliveryErrors != null && deliveryErrors.hasShippingZipCodeError) {
      return localeKeys.deliverySection.error.missingZipCode();
    } else {
      return localeKeys.deliverySection.error.unsupportedRegion();
    }
  };
  return /*#__PURE__*/React.createElement(SectionNotification, {
    "data-hook": UnsupportedShippingDestinationErrorHooks.noShippingMessage(),
    type: "error"
  }, /*#__PURE__*/React.createElement(SectionNotification.Icon, {
    icon: /*#__PURE__*/React.createElement(ErrorIcon, null)
  }), /*#__PURE__*/React.createElement(SectionNotification.Text, null, getErrorMessage()));
};
//# sourceMappingURL=UnsupportedShippingDestinationError.js.map